<template>
  <a-form
    :model="model"
    layout="inline"
    class="table-cell-form"
  >
    <div
      v-show="is_show_field"
      class="field-cell-item"
      :class="{ editable: editable, 'item-required': has_reqrired }"
    >
      <field-render-2
        v-if="field.type !== 'dynamicvaluefield'"
        :is_show_label="false"
        v-model:value="model[field.name]"
        v-model:label="model[field.name + '.label']"
        v-model:is_show_field="is_show_field"
        :field="field"
        :formModel="model"
        :key="field.name"
        :validateInfos="validateInfos"
        :options="options[field.datasource ? field.datasource : field.name]"
        :context="context"
        :inner-model="innerModel"
        :global-inner-model="globalInnerModel"
        :nestValidate="nestValidate"
        :base-key-path="baseKeyPath"
        :worker-host-functions="workerHostFunctions"
        :is_form_design="is_form_design"
        @update_model="onUpdateModel"
        @update_name2="onUpdateName2"
      />
      <span v-else>{{ model[field.name] }}</span>
    </div>
  </a-form>
</template>
<script setup lang="ts">
import { computed, PropType, ref } from 'vue';
import FieldRender2 from 'liyu-pc-base/components/FormRender/FieldRender2.vue';

const props = defineProps({
  field: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  validateInfos: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    default: () => {
      return {};
    },
  },
  context: {
    type: Object,
    default: () => {
      return {};
    },
  },
  innerModel: {
    default: null,
  },
  globalInnerModel: {
    default: null,
  },
  nestValidate: {
    type: Object as PropType<Record<string, any> | null>,
    default: null,
  },
  baseKeyPath: {
    type: Array,
    default: () => [],
  },
  workerHostFunctions: {
    type: Object,
    required: true,
  },
  is_form_design: {
    type: Boolean,
    default: false,
  },
  has_reqrired: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['update_model', 'update_name2']);
const is_show_field = ref(true);
const onUpdateModel = params => {
  emit('update_model', params);
};
const onUpdateName2 = params => {
  emit('update_name2', params);
};
const editable = computed(() => {
  return is_show_field.value && !props.field.disabled && props.field.type !== 'dynamicvaluefield';
});
</script>
<style lang="less" scoped>
.table-cell-form {
  display: block;
}
.field-cell-item {
  padding: 8px;
  box-sizing: border-box;
  height: 100%;

  :deep(.ant-input-clear-icon) {
    display: none;
  }
  &:has(:focus),
  &:hover {
    :deep(.ant-input-clear-icon) {
      display: block;
    }
  }
}
:deep(.ant-form-item) {
  margin: 0 !important;
}
:deep(.ant-input-affix-wrapper) {
  border: 0 !important;
  background-color: transparent !important;
  padding: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
:deep(.ant-input) {
  background-color: transparent !important;
  outline: none !important;
  border: 0 !important;
  box-shadow: none !important;
}
:deep(.ant-select-selector) {
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
}
:deep(.ant-select-selector) {
  background: none !important;
}
:deep(.ant-input-number) {
  background-color: transparent !important;
  outline: none !important;
  box-shadow: none !important;
  border: 0 !important;
}
:deep(.ant-input-group-addon) {
  border: none !important;
  background: none !important;
}
:deep(.ant-input-number-group-addon) {
  border: none !important;
  background: none !important;
}
:deep(.ant-input-number-affix-wrapper) {
  border: none !important;

  background: none !important;
}
:deep(.ant-input-number-input) {
  padding: 0 !important;
}
:deep(.ant-input-number-handler-wrap) {
  display: none !important;
}
:deep(.ant-form-item-control-input-content) {
  .ant-layout {
    background: none;
  }
}
.editable.item-required {
  :deep(.ant-form-item::before) {
    display: inline-block;
    position: absolute;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
:deep(.ant-picker) {
  background-color: transparent !important;
  outline: none !important;
  border: 0 !important;
  box-shadow: none !important;
}
</style>
